import { render, staticRenderFns } from "./remarkInfo.vue?vue&type=template&id=340a8b5e&scoped=true&"
import script from "./remarkInfo.vue?vue&type=script&lang=js&"
export * from "./remarkInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340a8b5e",
  null
  
)

export default component.exports